(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define("ReactDiscordPresence", ["React"], factory);
	else if(typeof exports === 'object')
		exports["ReactDiscordPresence"] = factory(require("react"));
	else
		root["ReactDiscordPresence"] = factory(root["React"]);
})(self, (__WEBPACK_EXTERNAL_MODULE_react__) => {
return 